import { HttpParams } from "@angular/common/http";
import { AppConstants } from "../../common/constants/app-constants";
import { JobStatus, JobType } from "../constants/keep-basic-data";
import { CarBusinessLine } from "../../car/constants/car-basic-data";


export class JobCriteria {
  pageNumber: number = 0;
  pageSize: number = AppConstants.PAGE_SIZE_DEFAULT;
  
  jobIds : string[] = [];

  customerIds : string[] = [];
  ownerIds : string[] = [];
  providerIds : string[] = [];

  carIds : string[] = [];

  jobTypes : JobType[] = [];
  jobStatuses : JobStatus[] = [];

  makes : string[] = [];
  models : string[] = [];
  gearboxes : string[] = [];
  fuelTypes : string[] = [];

  countries : string[] = [];
  cities : string[] = [];

  jobStartDate  = "";
  jobEndDate = "" ;

  businessLine? : CarBusinessLine = CarBusinessLine.BUY;

  constructor(){
 }

  public getHttpParams(): HttpParams {
    
    return new HttpParams()
                .append('pageNumber', this.pageNumber)
                .append('pageSize', this.pageSize)

                .append('jobIds', this.jobIds.join(', '))

                .append('customerIds', this.customerIds.join(', '))
                .append('ownerIds', this.ownerIds.join(', '))
                .append('providerIds', this.providerIds.join(', '))

                .append('carIds', this.carIds.join(', '))
                
                .append('jobTypes', this.jobTypes.join(', '))
                .append('jobStatuses', this.jobStatuses.join(', '))

                .append('makes', this.makes.join(', '))
                .append('models', this.models.join(', '))
                .append('gearboxes', this.gearboxes.join(', '))
                .append('fuelTypes', this.fuelTypes.join(', '))

                .append('countries', this.countries.join(', '))
                .append('cities', this.cities.join(', '))

                .append('jobStartDate', this.jobStartDate)
                .append('jobEndDate', this.jobEndDate);
    
  }
}